import React from 'react';

import { t } from "../i18n";
import './captcha_terms.scss';

const CaptchaTerms = ({ signedIn }) => {
  if (signedIn) {
    return null;
  } else {
    return (<div className="captcha-terms">{t("site-protected-by")} <a href="https://policies.google.com/privacy">{t("privacy-policy")}</a> {t("and")} <a href="https://policies.google.com/terms">{t("terms-service")}</a> {t("apply")}.
    </div>)
  }
}

export default CaptchaTerms;



// WEBPACK FOOTER //
// ./app/javascript/captcha_terms/captcha_terms.js